import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Toast 輔助函數
export const showToast = {
  success: (message) => {
    if (typeof window !== 'undefined') {
      toast.dismiss(); // 在顯示新的 toast 前，先清除現有的
      toast.success(message);
    }
  },
  error: (message) => {
    if (typeof window !== 'undefined') {
      toast.dismiss();
      toast.error(message);
    }
  },
  info: (message) => {
    if (typeof window !== 'undefined') {
      toast.dismiss();
      toast.info(message);
    }
  },
  warning: (message) => {
    if (typeof window !== 'undefined') {
      toast.dismiss();
      toast.warning(message);
    }
  }
};